import ServiceImageCards from './serviceImageCards';

export default ServiceImageCards;
